<h1 mat-dialog-title><mat-icon>{{data.icon}}</mat-icon>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">No</button>&nbsp;
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Sí</button>
</div>